var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-wrapper tenancy-marketing-contacts" },
    [
      _c("div", { staticClass: "table-caption" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("tenancy.table.marketing")) + "\n  "),
      ]),
      _vm._v(" "),
      _vm.allowLinkContacts
        ? _c("div", { staticClass: "link__contact" }, [
            _c(
              "button",
              {
                staticClass: "btn link__contact--btn",
                attrs: { type: "button", disabled: !_vm.tenancyId },
                on: {
                  click: function ($event) {
                    return _vm.linkFunc({ isMarketing: true })
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("tenancy.table.linkContact")) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "link__contact--plus" }, [_vm._v("+")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c(
            "tr",
            [
              _vm._l(_vm.itemHeaders, function (header, index) {
                return _c("th", { key: index, class: header.class }, [
                  _vm._v("\n          " + _vm._s(header.name) + "\n        "),
                ])
              }),
              _vm._v(" "),
              _c("th"),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.marketingContacts, function (item, index) {
            return _c("tr", { key: index }, [
              _c(
                "td",
                { staticClass: "select-roles" },
                [
                  _vm.allowLinkContacts
                    ? _c("HKLMultiSelect", {
                        staticClass: "multi-value",
                        class:
                          _vm.deep(item, "CompanyContact.roleType").length === 0
                            ? "error-highlight-floor"
                            : "",
                        attrs: {
                          value: _vm.deep(item, "CompanyContact.roleType"),
                          options: _vm.roleHklOptions,
                          placeholder: "",
                        },
                        on: {
                          change: function (val) {
                            return _vm.updatePathField(index, "roleType", val)
                          },
                        },
                      })
                    : _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm
                              .deep(item, "CompanyContact.roleType")
                              .join(", ") || "--"
                          )
                        ),
                      ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("td", { staticClass: "number-column" }, [
                _vm.canAccessContact
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          staticClass: "name-hyper-link",
                          on: {
                            click: function ($event) {
                              return _vm.navToContactDetail(item.id, true)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.displayI18nFullName(
                                item.firstName,
                                item.lastName
                              ) || item.name
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isEngineer
                        ? _c("i", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !!item.remarks,
                                expression: "!!item.remarks",
                              },
                            ],
                            staticClass: "remark-included-flag",
                          })
                        : _vm._e(),
                    ])
                  : _c("div", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.displayI18nFullName(
                              item.firstName,
                              item.lastName
                            ) || item.name
                          ) +
                          "\n          "
                      ),
                    ]),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "number-column" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("isEmptyValue")(item.phone)) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "select-marketing-emails" },
                [
                  _vm.allowLinkContacts
                    ? _c("HKLMultiSelect", {
                        staticClass: "multi-value",
                        class:
                          _vm.deep(item, "CompanyContact.mEmails").length === 0
                            ? "error-highlight-floor"
                            : "",
                        attrs: {
                          value: _vm.deep(item, "CompanyContact.mEmails"),
                          options: _vm.emailHklOptions(item),
                          placeholder: "",
                        },
                        on: {
                          change: function (val) {
                            return _vm.updatePathField(index, "mEmails", val)
                          },
                        },
                      })
                    : _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm
                              .deep(item, "CompanyContact.mEmails")
                              .join(", ") || "--"
                          )
                        ),
                      ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("TextField", {
                    directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                    attrs: {
                      parentNode: "",
                      value: _vm.deep(item, "CompanyContact.mRemarks"),
                      disabled: !_vm.allowLinkContacts,
                      readonly: !_vm.allowLinkContacts,
                    },
                    on: {
                      updateValue: function (val) {
                        return _vm.updateRemarks(index, val)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("td", { staticClass: "icon-remove" }, [
                _vm.allowLinkContacts
                  ? _c("i", {
                      staticClass: "fa fa-times-thin",
                      on: {
                        click: function ($event) {
                          return _vm.openDeleteConfirm(index, item)
                        },
                      },
                    })
                  : _vm._e(),
              ]),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "deleteConfirmModal",
        attrs: {
          modalId: _vm.delConfModalId,
          confirmTitle: _vm.$t("deleteConfirmMsg"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }